import React, { useMemo } from "react";
import InputYearMonthDay, {
  InputYearMonthDayProps
} from "../InputYearMonthDay";

export interface InputDateOfBirthProps extends InputYearMonthDayProps {
  /**
   * The minimum age allowed for setting the date of birth.
   *
   * @default 16
   */
  minimumAge?: number;
  /**
   * The maximum age allowed for setting the date of birth.
   *
   * @default 120
   */
  maximumAge?: number;
}

export default function InputDateOfBirth({
  minimumAge = 16,
  maximumAge = 120,
  ...inputProps
}: InputDateOfBirthProps) {
  const _inputProps = useMemo(
    () => ({
      ...inputProps,
      startYear:
        new Date().getUTCFullYear() -
        (minimumAge ? minimumAge - 1 : minimumAge),
      numYears: maximumAge - minimumAge
    }),
    [inputProps, minimumAge, maximumAge]
  );

  return <InputYearMonthDay {..._inputProps} />;
}
